export default function getMessagesString(count) {
    if (count === 1) {
        return `${count} сообщение`;
    } else if (count >= 2 && count <= 4) {
        return `${count} сообщения`;
    } else {
        return `${count} сообщений`;
    }
}